<mat-calendar #calendar [selected]="selectedWeekStart" (selectedChange)="onDateSelected($event)"
    [dateClass]="dateClass">
</mat-calendar>
